export class CustomLoader {
    isLoading: boolean;
    text: string;
}